import type { FieldMapperProps } from "@/features/fields-grid";
import { type EventAssertion, type Field, FieldType } from "@/entities/form-metadata";
import { EventGroupDayInput } from "./DayInput";
import { EventGroupMonthInput } from "./MonthInput";
import { EventGroupPlaceInput } from "./PlaceInput";
import { EventGroupYearInput } from "./YearInput";
import { YearRangeInput } from "./YearRangeInput";
import { useEventFieldFocusTracking } from "./useEventFieldFocusTracking";

export function FieldMapper({
    fieldData,
    fieldPath,
    assertion,
    fieldsetLabel,
    relation,
    eventType,
    inputProperties,
}: FieldMapperProps<EventAssertion>) {
    const getFocusTracking = useEventFieldFocusTracking();

    if (fieldData.fieldType === FieldType.YearRange && assertion === "Year") {
        return (
            <YearRangeInput
                fieldData={fieldData}
                fieldPath={fieldPath}
                fieldsetLabel={fieldsetLabel}
                relation={relation}
                eventType={eventType}
                inputProperties={inputProperties}
            />
        );
    }

    const { onFocus } = getFocusTracking(relation, eventType, assertion);

    switch (assertion) {
        case "Day":
            return (
                <EventGroupDayInput
                    fieldPath={fieldPath}
                    fieldData={fieldData as Field<EventAssertion>}
                    inputProperties={{ ...inputProperties, onFocus }}
                />
            );
        case "Month":
            return (
                <EventGroupMonthInput
                    fieldPath={fieldPath}
                    fieldData={fieldData as Field<EventAssertion>}
                    inputProperties={{ ...inputProperties, onFocus }}
                />
            );
        case "Year":
            return (
                <EventGroupYearInput
                    fieldData={fieldData}
                    fieldPath={fieldPath}
                    inputProperties={{ ...inputProperties, onFocus }}
                />
            );
        case "Place":
            return (
                <EventGroupPlaceInput
                    fieldData={fieldData}
                    fieldPath={fieldPath}
                    inputProperties={{ ...inputProperties, onFocus }}
                />
            );
        default:
            // TODO: add here new relic error log
            return null;
    }
}
